import Select, { Option } from 'bloko/blocks/select';

import useTrls from 'hooks/translation/useTrls';

import ClickmeFormItem from 'components/ClickmeFormItem';

import { InvoicePayerType } from 'store/models/invoices';
import { setPayerType } from 'store/models/payerCreate';
import { useDispatch, useSelector } from 'store/utils';

const DATA_QA_BY_PAYER_TYPE = {
    [InvoicePayerType.Legal]: 'legal-payer',
    [InvoicePayerType.Individual]: 'individual-payer',
    [InvoicePayerType.Natural]: 'natural-payer',
};

const PayerType = () => {
    const dispatch = useDispatch();
    const { payerType, availablePayerTypes } = useSelector((state) => state.payerCreate);
    const trl = useTrls();

    return (
        <ClickmeFormItem
            input={
                <Select
                    value={payerType}
                    onChange={(event) => dispatch(setPayerType(event.target.value))}
                    disabled={availablePayerTypes.length < 2}
                    data-qa="payer-type"
                >
                    {availablePayerTypes.map((type) => (
                        <Option key={type} value={type} data-qa={DATA_QA_BY_PAYER_TYPE[type]}>
                            {trl(`InvoiceAndPayerForm.PayerCreate.PayerType.${type}`)}
                        </Option>
                    ))}
                </Select>
            }
            legend={trl('InvoiceAndPayerForm.PayerCreate.PayerType.legend')}
            hint={trl('InvoiceAndPayerForm.PayerCreate.PayerType.hint')}
        />
    );
};

export default PayerType;
